/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlUpgradeResponseRequest
 */
export interface ControlUpgradeResponseRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlUpgradeResponseRequest
     */
    jwt: string;
}

/**
 * Check if a given object implements the ControlUpgradeResponseRequest interface.
 */
export function instanceOfControlUpgradeResponseRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jwt" in value;

    return isInstance;
}

export function ControlUpgradeResponseRequestFromJSON(json: any): ControlUpgradeResponseRequest {
    return ControlUpgradeResponseRequestFromJSONTyped(json, false);
}

export function ControlUpgradeResponseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUpgradeResponseRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jwt': json['jwt'],
    };
}

export function ControlUpgradeResponseRequestToJSON(value?: ControlUpgradeResponseRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jwt': value.jwt,
    };
}

